

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface DiagnosisParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Diagnosis {
    id?: number;
    code:string;
    name: string;
    snomedCode: number;
    tenantId?: any;
    branchId?: any; 

    systemFlag:string;
    archiveFlag:string;
    updatedId?:number;
    mappingAttribute?:string;  
    localDescription?: string | null;   
  parameters?: DiagnosisParameter[];
  links?: any;
}

export abstract class DiagnosisData {
  abstract list(): Observable<Diagnosis[]>;
  abstract create(url: string,data: Diagnosis): Observable<any>;
  abstract update(url: string,data: Diagnosis): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract searchList(url:string,data:any): Observable<any>;
}